export default "/assets/images/home-wrecker5.png?8e4d43ec4131f2c0246f12eb81b9207b";